import React from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const MiniCart = () => {
  const dispatch = useDispatch();
  const {
    quantity,
    orderTotal,
    checkoutUrl,
    showInfo,
    orderRows,
  } = useSelector((state) => state.cart);

  const onToggle = () => {
    dispatch(toggle());
  };
  const getOrderCount = (orderRows) => {
    return orderRows.length;
  };

  return (
    <div className="cart cart--mini">
      <a
        className="cart__link--block" href={checkoutUrl}
      >
        <span>{translate('minicart.checkout')}</span>
        <svg>
          <use href="/ui/images/sprites/a-mobler.svg#cart"></use>
        </svg>
        <span className="cart__quantity">{quantity}</span>
      </a>
      <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
        {getOrderCount(orderRows) <= 0 ? (
          <div>
            <span
              className="cart__close-button"
                rel="nofollow"
                href="#"
              onClick={(e) => {
                e.preventDefault();
                onToggle();
              }}
            >
              <svg>
                <use href="/ui/images/sprites/a-mobler.svg#close"></use>
              </svg>
            </span>
            <p className="cart__info-row">
              {quantity} {translate('minicart.numberofproduct')}
            </p>
            <p className="cart__info-row">
              <b>{translate('minicart.total')}</b> {orderTotal}
            </p>
            <a href={checkoutUrl} className="button__secondary">
              {translate('minicart.checkout')}
            </a>
          </div>
        ) : (
          <div>
            <h5 className="cart__info-row">
              {translate('minicart.product.message.success')}
            </h5>
            <span
              className="cart__close-button"
              onClick={(e) => {
                e.preventDefault();
                onToggle();
              }}
            >
              <svg>
                <use href="/ui/images/sprites/a-mobler.svg#close"></use>
              </svg>
            </span>
            <ul className='cart__lists'>
              {orderRows.map((product, index) => {
                return (
                  <li
                    key={'li-mini-cart' + index}
                    className="cart__added-product-name"
                  >
                    <div className='cart__added--image'>
                      <img src={product.image}></img>
                    </div>
                    
                    <div className='cart__added--details'>
                      <p>{product.name}</p>
                      <span className='cart__added--quantity'><b>{translate('minicart.numberofproduct')}:</b> {product.quantity}</span>
                    </div>
                  </li>
                );
              })}
            </ul>

            <a className="button__secondary" href={checkoutUrl}>
              {translate('minicart.checkout')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default MiniCart;
